import "core-js/modules/es.object.to-string.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import { apiwxconfig } from '@/api';
import wx from 'wx';
import Devices from '@/utils/wxSdk';
var isInstall = false;
var install = function install(Vue, options) {
  // 开发环境免登
  if (isInstall) return;
  return new Promise(function (resolve, reject) {
    var data = {
      url: encodeURI(window.location.href.substring(0, window.location.href.indexOf('#')))
    };
    apiwxconfig(data).then(function (res) {
      var success = res.success,
        data = res.data;
      isInstall = true;
      if (success) {
        wx.config({
          debug: process.env.NODE_ENV !== 'production',
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appid,
          // 必填，公众号的唯一标识
          timestamp: data.timeStamp,
          // 必填，生成签名的时间戳
          nonceStr: data.nonceStr,
          // 必填，生成签名的随机串
          signature: data.signature,
          // 必填，签名
          jsApiList: ['scanQRCode', 'chooseWXPay', 'updateAppMessageShareData', 'updateAppMessageShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems'] // 必填，需要使用的JS接口列表
        });
        wx.ready(function (e) {
          console.log('AutoConsole: ready -> e', e);
          Vue.prototype.$DingTalk = Devices;
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        });
      }
    }).catch(function (e) {
      return console.log(e);
    });
  });
};
export { install };